import _ from 'lodash';
import { Typography } from '@scale/scaleui';

export function MetadataDisplay({ metadata }: { metadata: { [key: string]: any } }) {
  return (
    <>
      {_.size(metadata) > 0 && (
        <div className="rounded-md border border-neutral-200 p-4">
          {Object.entries(metadata).map(([k, v]) => (
            <div className="flex justify-between items-center" key={k}>
              <Typography.Subtitle3>{k}</Typography.Subtitle3>
              <code className="text-xs">{JSON.stringify(v)}</code>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
